import { GraphqlUserDataOutput } from 'src/graphql/models/user-data.output.model';
import { UserData } from 'src/models/user-data.model';

/**
 * Maps user data as received from the authentication source to internal model.
 * @param input GraphQL output of user data.
 * @returns Internal model.
 */
export function convertGraphqlUserDataOutputToUserData(input: GraphqlUserDataOutput): UserData {
	return {
		userName: input.Username,
		sessionID: input.SessionUID,
		companyName: input.Company,
		email: input.Email,
		firstName: input.FirstName,
		lastName: input.LastName,
		functionalGroups: input.FunctionalGroups,
	};
}
